import { render, staticRenderFns } from "./ChangeEmailForm.vue?vue&type=template&id=1dde6465&scoped=true&"
import script from "./ChangeEmailForm.vue?vue&type=script&lang=js&"
export * from "./ChangeEmailForm.vue?vue&type=script&lang=js&"
import style0 from "./ChangeEmailForm.vue?vue&type=style&index=0&id=1dde6465&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dde6465",
  null
  
)

export default component.exports